import { CommonLaboratoryDatasource } from '@/shared/resources/datasources/common/common-laboratory-datasource'
import { AppliedBillableConceptResponse } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { billingAppliedBillableConceptService } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.service'
import { CommonFilterModel, CommonParams, ExportCommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { store } from '@/store/store'
import { GridUtils } from '@/shared/util/grid-utils'
import { ReportGridRequest } from '@/api/services/common.dto'
import { AxiosResponse } from 'axios'

export class BillingModalDeliveryNotesCrudGridDatasource extends CommonLaboratoryDatasource<AppliedBillableConceptResponse> {
    private readonly _deliveryNoteId: number | undefined

    constructor(deliveryNoteId?: number) {
        super(store.getters.labId)
        this._deliveryNoteId = deliveryNoteId
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<AppliedBillableConceptResponse>> {
        const _filterModel: CommonFilterModel = { ...filterModel }
        if (this._deliveryNoteId) {
            _filterModel['deliveryNote.id'] = GridUtils.getNumberFilterModel('equals', this._deliveryNoteId)
        }
        return billingAppliedBillableConceptService.paginator(_filterModel, params, this.laboratoryId)
    }

    public exporter(request: ReportGridRequest, params: ExportCommonParams): Promise<AxiosResponse<Blob>> {
        const filterModel: CommonFilterModel = { ...request.filterModel }
        if (this._deliveryNoteId) {
            filterModel['deliveryNote.id'] = GridUtils.getNumberFilterModel('equals', this._deliveryNoteId)
        }
        const _request: ReportGridRequest = { ...request, filterModel }
        return billingAppliedBillableConceptService.export(this.laboratoryId, _request, params)
    }
}
